import { Component, OnInit } from '@angular/core';
import { FeedbackService } from 'src/app/services/feedback.service';
import { ImagesService } from 'src/app/services/images.service';

@Component({
    selector: 'app-photo-of-week',
    templateUrl: './photo-of-week.component.html',
    styleUrls: ['./photo-of-week.component.css']
})
export class PhotoOfWeekComponent implements OnInit {

    complete = false;

    photo: any = undefined;
    businesses = [
        { id: 1, name: 'Byfords' },
        { id: 3, name: 'The Pigs' },
        { id: 6, name: 'Ffolkes' },
    ]

    constructor(
        private imagesService: ImagesService,
        private feedbackService: FeedbackService,
    ) { }

    ngOnInit(): void {
        this.getPhotoOfWeek();
    }

    getPhotoOfWeek() {
        this.feedbackService.getPhotoOfWeek().subscribe(data => {
            console.log(data);
            this.photo = data;
        })
    }

    savePhotoData() {
        this.complete = false;
        this.feedbackService.setPhotoOfWeek(this.photo).subscribe(data => {
            console.log(data);
            this.complete = true;
        })
    }

    setImage(e: any) {
        console.log(e.URL);
        this.photo.url = e.URL;
        // this.data.bannerImage = e.URL;

    }

    deleteImage(idx: number) {
        // this.imagesService.delete(this.data.images[idx]).subscribe(data => { });
        // this.data.images.splice(idx, 1);
    }

}
